import { useEffect, useMemo, useRef, useState } from 'react';

import CubeExplosion from '@/components/game/3d/animation/CubeExplosion';
import EnergyComposed from '@/components/game/3d/object/piece/EnergyComposed';

const CarbonFootprintBuilder = ({ carbonFootprint, playerId }) => {
	if (carbonFootprint == null) return null;

	const STEP = 0.75;

	const prev = useRef(carbonFootprint);
	const [explosions, setExplosions] = useState<any[]>([]);

	const energyArray = useMemo(() => {
		const arr: any = [];

		for (let i = 0; i < carbonFootprint; i++) {
			const energyColor = 'black';

			let energyObj = {
				id: `cf-${energyColor}-${i}`,
				color: energyColor,
				type: 'cf',
				homePosition: [i * 1, 0, 0],
			};

			arr.push(<EnergyComposed key={energyObj.id} energy={energyObj} />);
		}
		return arr;
	}, [carbonFootprint]);

	useEffect(() => {
		const prevCount = prev.current;
		const currCount = carbonFootprint;

		if (currCount < prevCount) {
			const removed = prevCount - currCount;

			for (let i = 0; i < removed; i++) {
				const index = currCount + i;

				setExplosions((e) => [
					...e,
					{
						id: crypto.randomUUID(),
						pos: [index * STEP, 0, 0],
					},
				]);
			}
		}

		prev.current = currCount;
	}, [carbonFootprint]);

	return (
		<group
			key={`carbon_footprint_group_${playerId}`}
			position={[-5, 6, 12.75]}
			rotation={[0, Math.PI * 1.5, 0]}
		>
			{energyArray}
			{explosions.map((e) => (
				<CubeExplosion
					key={e.id}
					position={e.pos}
					color="black"
					onDone={() =>
						setExplosions((prev) =>
							prev.filter((x) => x.id !== e.id)
						)
					}
				/>
			))}
		</group>
	);
};

export default CarbonFootprintBuilder;
